export default "__VITE_ASSET__30b50482__"